import React from 'react'

type Props = {
  className?: string
  fillColor?: string
  size?: number
}

// Clock face with an alert dot (Lucide clock-alert, Figma 2748:24568) — flags
// an Olo webhook connection that's gone quiet long enough to need
// reconnecting. Stroked, matching the ClockArrowUp/BookOutline convention so
// it satisfies the shared outlined-icon test contract.
const ClockAlert = ({
  className,
  fillColor = 'currentColor',
  size = 16,
}: Props) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 18.0433 18.6667"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    fill="none"
    stroke={fillColor}
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M9.33476 4.337V9.337L12.6681 11.0037M16.0014 9.337V13.5037M16.0014 16.837H16.0098M17.0431 6.17035C16.4145 4.63816 15.3436 3.32801 13.9671 2.40712C12.5906 1.48623 10.971 0.996352 9.31488 1.00002C7.65876 1.00369 6.0413 1.50073 4.66891 2.42771C3.29653 3.3547 2.23147 4.66957 1.60967 6.20453C0.987868 7.73949 0.837527 9.42491 1.17783 11.0457C1.51814 12.6665 2.33365 14.1491 3.5203 15.3044C4.70695 16.4596 6.2109 17.2351 7.84023 17.5318C9.46955 17.8285 11.1503 17.6331 12.6681 16.9704" />
  </svg>
)

export default ClockAlert
